<template>
  <section>
    <div class="limiter-content pa-2 pa-lg-0">
      <div class="padding-block"></div>

      <header class="cs-header">
        <span class="cs-eyebrow"><v-icon small color="primary">mdi-briefcase-outline</v-icon> CASOS / EMPRESAS</span>
        <h1 class="cs-title">Recuperações <span>judiciais</span></h1>
      </header>

      <div v-html="dataset.description"></div>

      <filter-component :type="1"></filter-component>

      <v-row>
        <whatsButton />
      </v-row>

      <v-row>
        <topButton />
      </v-row>

    </div>
  </section>
</template>

<script>
import 'moment/locale/pt-br'

import { eventHub } from '@/main'

import axios from 'axios'

import FilterComponent from '@/components/cases/FilterComponent.vue';
import topButton from '@/components/layout/GoToTopButton.vue';
import whatsButton from '@/components/layout/WhatsAppButton.vue';

export default {
  data: () => ({
    user: null,
    dialogPopup: false,
    dataset: {
      description: ''
    },

  }),

  components: {
    FilterComponent,
    topButton,
    whatsButton,
  },

  created() {
    this.$ga.event({
      eventCategory: 'page',
      eventAction: 'action',
      eventLabel: 'click',
      eventValue: 'home'
    })

    this.loadText()
  },

  methods: {
    openRegister() {
      eventHub.$emit('DIALOG-REGISTER', true)
    },

    async loadText() {
      try {
        const result = await axios.get(`/api/dynamic-infos/keys`, {
          params: { keys: 'judicial-recovery-description' }
        })

        this.dataset.description = result.data.content && result.data.content.length > 0 ? result.data.content[0].value : '';

      } catch (error) {
        this.$dialog.notify.error(this.$codes(error), {
          position: 'top-right',
          timeout: 2000
        })
      }
    }
  }
}
</script>

<style lang="scss">
.title-page {
  font-family: 'Raleway';
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

.underline::after {
  content: '';
  display: block;
  margin: 5px 0;
  height: 3px;
  width: 180px;
  background: var(--v-primary-base);
}

.title-h1 {
  font-size: 40px;
  color: var(--v-mediumGray-base);
}

.text-p {
  font-size: 20px;
  font-family: 'Raleway';
}

.sub-title {
  color: rgb(75, 72, 72);
  font-family: 'Raleway';
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 38px;
}

.formFields {
  width: 100%;
  margin-bottom: -30px;
}

.findForm {
  width: 90%;
  margin-right: -15px;
  margin-left: 15px;
}

.findButton {
  margin-right: 0px !important;
  margin-top: 1px !important;
  font-family: Raleway, sans-serif;
  font-size: 30px !important;
  width: 150px !important;
  height: 40px !important;
  color: white !important;
  background-color: #009986 !important;
  transition: background-color 0.3s ease;
}

.findButton:hover {
  background-color: #0077cc !important;
}

.table-spacing tbody tr {
  margin-bottom: 10px;
}

.table-bordered td {
  border-bottom: 1px solid #ddd;
  padding: 8px;
}

.table-bordered tbody tr:first-child td {
  border-top: 1px solid #ddd;
}
</style>

<style scoped>
/* Titulo no formato das telas da area do credor/procurador. */
.cs-header { padding: 32px 0 20px; }
.cs-eyebrow { display: flex; gap: 8px; align-items: center; font-size: 11px; font-weight: 700; letter-spacing: .12em; color: #766386; }
.cs-title { margin: 14px 0 0; font-size: clamp(28px, 3.4vw, 40px); font-weight: 700; color: #25113c; letter-spacing: -.035em; line-height: 1.2; }
.cs-title span { color: #806697; }
</style>
